module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjkiIGhlaWdodD0iNzkiIHZpZXdCb3g9IjAgMCA2OSA3OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOm11bHRpcGx5Ij4KPHBhdGggZD0iTTY5IDM5LjVMMC43NDk5OTYgNzguOTA0MkwwLjc1IDAuMDk1ODQxM0w2OSAzOS41WiIgZmlsbD0iIzRDNEM0QyIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play.svg
// module id = 851
// module chunks = 117